import { InputAlert } from '@creditornot/cb-input';
import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useOfferingMenuFeaturesContext } from 'modules/shared-menu/contexts/OfferingMenuFeaturesContext';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';
import { StyledRadioCard, UnitDetailsSelectionWrapper } from '../OfferDetailsFormFields.styles';
import { BasicDetails, FormValues } from '../types';

export const ItemType = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const menuFeatures = useOfferingMenuFeaturesContext();
  const { values } = useFormState<FormValues>();
  const intl = useIntl();

  const previewComponent = !!offer?.sell_by_weight_config ? (
    <FormattedMessage id="menu-item.unit-details-view-selection.weighted-items.label" />
  ) : (
    <FormattedMessage id="menu-item.unit-details-view-selection.pre-packaged.label" />
  );

  const editComponent = (
    <>
      <Field<BasicDetails['weightType']> name="weightType">
        {({ input }) => (
          <UnitDetailsSelectionWrapper>
            {[
              {
                value: 'pre-packaged' as const,
                label: intl.formatMessage({ id: 'menu-item.unit-details-view-selection.pre-packaged.label' }),
                subContent: intl.formatMessage({
                  id: 'menu-item.unit-details-view-selection.pre-packaged.sub-content',
                }),
              },
              {
                value: 'weighted-items' as const,
                label: intl.formatMessage({ id: 'menu-item.unit-details-view-selection.weighted-items.label' }),
                disabled: !menuFeatures.supportWeightedItems,
                subContent: intl.formatMessage({
                  id: 'menu-item.unit-details-view-selection.weighted-items.sub-content',
                }),
              },
            ].map(({ value, label, subContent, disabled }) => (
              <StyledRadioCard
                key={value}
                disabled={!!disabled}
                onChange={() => input.onChange(value)}
                checked={input.value === value}
                label={label}
                subContent={subContent}
              />
            ))}
          </UnitDetailsSelectionWrapper>
        )}
      </Field>
      {values.optionBindings.length > 0 && values.weightType === 'weighted-items' && (
        <InputAlert variant="info">
          <FormattedMessage id="menu-item.unit-details-view-selection.options-warning" />
        </InputAlert>
      )}
    </>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.item-type' })}
      previewComponent={previewComponent}
      required
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
